export class Timezone {
  constructor(
    public id = '26',
    public displayLabel = '(GMT-05:00) Eastern Time (US & Canada)',
    public timezoneName = 'America/New_York',
  ) {}
}
